import React, { useEffect, useState } from "react";
import {
  postaxiosRequestWithToken,
  getaxiosRequestWithToken,
} from "../../api/api";
import { Modal, Button, Spinner, Form } from "react-bootstrap";
import { showToast } from "../../services/toastifyservices";
import CommonSpinner from "../../services/commonSpinner";
import { useNavigate } from "react-router-dom";
import { handleSession } from "../../api/apiSessionHandle";
import { FaEdit, FaMoneyBillWave } from "react-icons/fa";
import { formatPhoneNumber,validatePhoneNumber,validateEmail  } from "../../helper/common";
import endpoints from "../../api/EndPoints";
const PendingBalances = () => {
  const navigate = useNavigate();
  const [selectedName, setSelectedName] = useState("");
  const [patientData, setPatientData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [editedBillDue, setEditedBillDue] = useState("");
  const [billPending, setbillPending] = useState("");

  const [updateModal, setUpdateModal] = useState(false);
  const [initialUpdateForm, setInitialUpdateForm] = useState("");
  const [initialBillDue, setInitialBillDue] = useState("");
  const [payers, setPayers] = useState([]);
  const [errors, setErrors] = useState({});
  const [phoneerrors, setPhoneErrors] = useState({});

  const [updateForm, setUpdateForm] = useState({
    id: "",
    mrn: "",
    first_name: "",
    last_name: "",
    dob: "",
    gender: "",
    phone: "",
    email: "",
    primary_insurance_id: "",
    primary_insurance_number: "",
  });

  

  const handleChange = (e) => {
    let { name, value } = e.target;

    if (name === "email") {
      // Email validation
      if (!validateEmail(value)) {
        setErrors((prev) => ({ ...prev, email: "Invalid email format" }));
      } else {
        setErrors((prev) => {
          const { email, ...rest } = prev;
          return rest; // Remove email error when valid
        });
      }
    }

    if (name === "phone") {
      // Remove all non-numeric characters
      value = value.replace(/\D/g, "");

      if (value === "") {
        setPhoneErrors({});
      } else {
        // Format as (XXX) XXX-XXXX while typing
        if (value.length > 3 && value.length <= 6) {
          value = `(${value.slice(0, 3)}) ${value.slice(3)}`;
        } else if (value.length > 6) {
          value = `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6, 10)}`;
        }

        // Validation check for full 10-digit phone number
        if (value.length < 14) { // 14 includes formatted length "(212) 658-3916"
          setPhoneErrors((prev) => ({ ...prev, phone: "Invalid US phone number format" }));
        } else {
          setPhoneErrors((prev) => {
            const { phone, ...rest } = prev;
            return rest; // Remove phone error when valid
          });
        }
      }
    }

    // Update form state
    setUpdateForm((prev) => ({ ...prev, [name]: value }));
  };


  const handleUpdate = (patient) => {
    setSelectedPatient(patient);
    const initialData = {
      id: patient.id,
      mrn: patient.mrn,
      first_name: patient.first_name,
      last_name: patient.last_name,
      dob: patient.dob,
      gender: patient.gender,
      phone: patient.phone,
      email: patient.email,
      primary_insurance_id: patient.primary_insurance_id,
      primary_insurance_number: patient.primary_insurance_number,
    };
    setInitialUpdateForm(initialData); // Store the original data
    setUpdateForm(initialData); // Set the form with existing data
    setUpdateModal(true);
  };

  const handleSaveUpdate = async () => {
    try {
      if (!validateEmail(updateForm.email)) {
        showToast("error", "Invalid email format. Please enter a valid email.");
        return;
      }
      const response = await postaxiosRequestWithToken(
        endpoints.UpdatePatient,
        updateForm
      );
      if (response.success) {
        showToast("success", response.message);
        setUpdateModal(false);
        setPatientData((prev) =>
          prev.map((p) =>
            p.id === updateForm.id ? { ...p, ...updateForm } : p
          )
        );
      }
    } catch (error) {
      showToast("error", error.response?.data.message);
      handleSession(error.response?.data, navigate);
    }
  };

  const [formData, setFormData] = useState({
    mrn: "",
    first_name: "",
    last_name: "",
    dob: "",
    gender: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    phone: "",
    email: "",
    primary_insurance_id: "",
    primary_insurance_number: "",
  });
  const requiredFields = [
    "first_name",
    "last_name",
    "mrn",
    "dob",
    "phone",
    "email",
    "gender",
    "address",
    "city",
    "state",
    "zip",
    "primary_insurance_id",
    "primary_insurance_number",
  ];

  const isFormIncomplete = requiredFields.some(
    (field) => !formData[field]?.trim()
  );
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: name === "gender" ? value.toLowerCase() : value,
    }));
  };

  const handleSavePatient = async () => {
    if (!validateEmail(formData.email)) {
      showToast("error", "Invalid email format. Please enter a valid email.");
      return;
    }
    setLoading(true);
    try {
      const response = await postaxiosRequestWithToken(
        endpoints.SavePatient,
        formData
      );
      if (response.success) {
        showToast("success", response.message);
        setAddModal(false);
        setFormData("");
      }
    } catch (error) {
      showToast("error", error.response?.data.message);
      handleSession(error.response?.data, navigate);
    } finally {
      setLoading(false);
    }
  };
  const GetPatients = async () => {
    try {
      let payload = { input: selectedName };
      setLoading(true);
      const response = await getaxiosRequestWithToken(
        endpoints.searchpatient,
        payload
      );
      if (response.success && response.data.patients.data.length > 0) {
        setPatientData(response.data.patients.data);
      } else {
        setPatientData([]);
      }
    } catch (error) {
      showToast("error", error.response?.data.message);
      handleSession(error.response?.data, navigate);
      setPatientData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleBillDue = (patient) => {
    console.log("patient", patient)
    setSelectedPatient(patient);
    setEditedBillDue(patient.bill_due);
    setInitialBillDue(patient.bill_due);
    setbillPending(patient.bill_pending);
    setShowModal(true);
  };

  const updateBillDue = async () => {
    try {
      let payload = {
        bill_due: editedBillDue,
        mrn: selectedPatient.mrn,
        bill_pending: billPending,
      };
      const response = await postaxiosRequestWithToken(
        endpoints.UpdatePatientBillDue,
        payload
      );
      if (response.success) {
        const updatedPatients = patientData.map((patient) => {
          if (patient.mrn === selectedPatient.mrn) {
            return { ...patient, bill_due: editedBillDue };
          }
          return patient;
        });
        setShowModal(false);
        showToast("success", response.message);
        setPatientData(updatedPatients);
        GetPatients();
      }
    } catch (error) {
      showToast("error", error.response?.data.message);
      handleSession(error.response?.data, navigate);
    }
  };

  const fetchPayers = async () => {
    try {
      const response = await getaxiosRequestWithToken(endpoints.IssuancePayes);
      if (response.success) {
        setPayers(response.data.payers);
      }
    } catch (error) {
      console.log(error);
      showToast("error", error.response?.data.message);
    }
  };
  useEffect(() => {
    fetchPayers();
  }, []);


  const EmailhandleChange = (e) => {
    
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (name === "email") {
      if (value == "") {
        setErrors({});
      } else {
        if (!validateEmail(value)) {
          setErrors({ ...errors, email: "Invalid email format" });
        } else {
          let newErrors = { ...errors };
          delete newErrors.email;
          setErrors(newErrors);
        }
      }

    }
  };

  const handlePhoneChange = (e) => {
    let { name, value } = e.target;
  
    value = formatPhoneNumber(value); // Format the phone number
    setFormData({ ...formData, [name]: value });
  
    if (value === "") {
      setPhoneErrors({});
    } else if (!validatePhoneNumber(value)) {
      setPhoneErrors({ ...errors, phone: "Invalid US phone number format" });
    } else {
      let newErrors = { ...errors };
      delete newErrors.phone;
      setPhoneErrors(newErrors);
    }
  };
  

  return (
    <div className="mt-3 p-2 md:p-10 bg-gray-200">
      <div className="card">
        <span className="text-start font-bold ml-4 p-2 headingtext">
          Pending Balance
        </span>
      </div>
      <div className="card p-3">
        <div className="row d-flex align-items-end justify-content-between">
          {/* Name Input and Search Button */}
          <div className="col-md-6 d-flex align-items-end">
            <div className="me-2 flex-grow-1">
              <label className="form-label font-bold">Name</label>
              <input
                type="text"
                className="form-control bigger-input"
                value={selectedName}
                onKeyDown={(e) => e.key === "Enter" && GetPatients()}
                onChange={(e) => setSelectedName(e.target.value)}
              />
            </div>
            <button
              className="btn btn-primary fw-bold btncolor"
              onClick={GetPatients}
              disabled={loading}
            >
              Search
            </button>
          </div>

          {/* Add Patient Button */}
          <div className="col-auto">
            <button
              className="btn btn-primary btnColor fw-bold"
              onClick={() => {
                setAddModal(true);
                setErrors({});
              }}
            >
              Add Patient
            </button>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="table-container">
          <table className="table table-striped table-hover">
            <thead className="table-header table-primary">
              <tr>
                <th>MRN</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Bill Due</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody className="table-body">
              {
                patientData.map((patient, index) => (
                  <tr key={index}>
                    <td>{patient.mrn}</td>
                    <td>{patient.first_name}</td>
                    <td>{patient.last_name}</td>
                    <td>{patient.phone || "Not recorded"}</td>
                    <td>{patient.email || "Not recorded"}</td>
                    <td>{patient.bill_due || "Not recorded"}</td>
                    <td>
                      <div className="d-flex gap-2">
                        <button
                          className="btn btn-sm btn-success"
                          onClick={() => handleBillDue(patient)}
                        >
                          <FaMoneyBillWave style={{ cursor: "pointer" }} />{" "}
                        </button>
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={() => handleUpdate(patient)}
                        >
                          <FaEdit style={{ cursor: "pointer" }} />{" "}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      </div>

      {/* Balance Summary Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Balance Summary</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedPatient ? (
            <div className="p-3 border rounded shadow-sm bg-light">
              <div className="row mb-3">
                <div className="col-md-6">
                  <h6 className="fw-bold">Name:</h6>
                  <p className="text-muted">
                    {selectedPatient.first_name} {selectedPatient.last_name}
                  </p>
                </div>
                <div className="col-md-6">
                  <h6 className="fw-bold">MRN:</h6>
                  <p className="text-muted">{selectedPatient.mrn}</p>
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-md-6">
                  <h6 className="fw-bold">Phone:</h6>
                  <p className="text-muted">
                    {selectedPatient.phone || "Not recorded"}
                  </p>
                </div>
                <div className="col-md-6">
                  <h6 className="fw-bold">Email:</h6>
                  <p className="text-muted">
                    {selectedPatient.email || "Not recorded"}
                  </p>
                </div>
              </div>
              <hr />
              <div className="row mb-3">
                <div className="col-md-6">
                  <h6 className="fw-bold">Bill Due:</h6>
                  <Form.Control
                    type="text"
                    value={editedBillDue}
                    onChange={(e) => setEditedBillDue(e.target.value)}
                    placeholder="Enter due amount"
                  />
                </div>
                <div className="col-md-6">
                  <h6 className="fw-bold">Bill Pending:</h6>
                  <Form.Control
                    type="text"
                    value={billPending}
                    onChange={(e) => setbillPending(e.target.value)}
                    placeholder="Enter Pending amount"
                  />
                </div>
              </div>
            </div>
          ) : (
            <p className="text-danger">No patient selected.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
          <Button
            variant="primary"
            disabled={editedBillDue === initialBillDue}
            onClick={updateBillDue}
          >
            Update Bill Due
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Update Patient Modal */}
      <Modal show={updateModal} onHide={() => setUpdateModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Update Patient</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
          <Form>
            <fieldset className="border p-3 rounded mb-4">
              <legend className="text-primary">Personal Information</legend>
              {[
                ["first_name", "last_name"], // Pair 1: First Name and Last Name
                ["mrn", "dob"], // Pair 2: MRN and Date of Birth
                ["phone", "email"], // Pair 3: Phone and Email
                ["gender"], // Single field: Gender
              ].map((pair, index) => (
                <div className="row mb-3" key={index}>
                  {pair.map((key) => (
                    <div className="col-md-6" key={key}>
                      <Form.Group>
                        <Form.Label className="fw-bold">
                          {key === "dob"
                            ? "Date of Birth"
                            : key.replace("_", " ").toUpperCase()}
                          : <span className="text-danger">*</span>
                        </Form.Label>
                        {key === "dob" ? (
                          <Form.Control
                            type="date"
                            name={key}
                            value={updateForm[key]}
                            onChange={handleChange}
                          />
                        ) : key === "gender" ? (
                          <Form.Select
                            name={key}
                            value={updateForm[key]}
                            onChange={handleChange}
                          >
                            <option value="">Select Gender</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                            <option value="other">Other</option>
                          </Form.Select>
                        ) : key === "email" ? (
                          <>
                            <Form.Control
                              type="email"
                              name={key}
                              value={updateForm[key]}
                              onChange={handleChange}
                            />
                            {errors.email && (
                              <div className="text-danger">{errors.email}</div>
                            )}
                          </>
                        ) : key === "phone" ? (
                          <>
                            <Form.Control
                              type="text" // Change type to text (to allow formatting)
                              name={key}
                              value={updateForm[key] || ""}
                              onChange={handleChange}
                              className={phoneerrors.phone ? "is-invalid" : ""}
                            />
                            {phoneerrors.phone && (
                              <div className="text-danger">{phoneerrors.phone}</div>
                            )}
                          </>
                        ) : (
                          <Form.Control
                            type="text"
                            name={key}
                            value={updateForm[key]}
                            onChange={handleChange}
                          />
                        )}
                      </Form.Group>
                    </div>
                  ))}
                </div>
              ))}
            </fieldset>
            <fieldset className="border p-3 rounded mb-4">
              <legend className="text-primary">Insurance Information</legend>
              <div className="row mb-3">
                {" "}
                {/* Wrap fields inside a Bootstrap row */}
                {["primary_insurance_id", "primary_insurance_number"].map(
                  (key) => (
                    <div className="col-md-6" key={key}>
                      {" "}
                      {/* Make each field take half width */}
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">
                          {key === "primary_insurance_id"
                            ? "Insurance Name"
                            : "Insurance Number"}
                          :<span className="text-danger">*</span>
                        </Form.Label>
                        {key === "primary_insurance_id" ? (
                          <Form.Select
                            name={key}
                            value={updateForm[key] || ""}
                            onChange={handleChange}
                          >
                            <option value="">Select Primary Insurance</option>
                            {payers.map((payer) => (
                              <option key={payer.id} value={payer.id}>
                                {payer.payer_name}
                              </option>
                            ))}
                          </Form.Select>
                        ) : (
                          <Form.Control
                            type="text"
                            name={key}
                            value={updateForm[key] || ""}
                            onChange={handleChange}
                          />
                        )}
                      </Form.Group>
                    </div>
                  )
                )}
              </div>
            </fieldset>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setUpdateModal(false)}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={handleSaveUpdate}
            disabled={
              JSON.stringify(updateForm) === JSON.stringify(initialUpdateForm)
            }
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Add Patient Modal */}
      <Modal
        show={addModal}
        onHide={() => {
          setAddModal(false);
          setFormData("");
        }}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Register Patient</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
          {/* Enable scrolling in modal body */}
          <Form>
            {/* Personal Information */}
            <fieldset className="border p-3 rounded mb-4">
              <legend className="text-primary">Personal Information</legend>
              {[
                ["first_name", "last_name"], // Pair 1: First Name and Last Name
                ["mrn", "dob"], // Pair 2: MRN and Date of Birth
                ["phone", "email"], // Pair 3: Phone and Email
                ["gender"], // Single field: Gender
              ].map((pair, index) => (
                <div className="row mb-3" key={index}>
                  {pair.map((key) => (
                    <div className="col-md-6" key={key}>
                      <Form.Group>
                        <Form.Label className="fw-bold">
                          {key === "dob"
                            ? "Date of Birth"
                            : key.replace("_", " ").toUpperCase()}
                          : <span className="text-danger">*</span>
                        </Form.Label>
                        {key === "dob" ? (
                          <Form.Control
                            type="date"
                            name={key}
                            value={formData[key] || ""}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                [key]: e.target.value,
                              })
                            }
                          />
                        ) : key === "phone" ? (
                          <>
                            <Form.Control
                              type="text"
                              name="phone"
                              value={formData.phone || ""}
                              onChange={handlePhoneChange}
                              className={phoneerrors.phone ? "is-invalid" : ""}
                            />
                            {phoneerrors.phone && <div className="text-danger">{phoneerrors.phone}</div>}</>

                        ) : key === "gender" ? (
                          <Form.Select
                            name={key}
                            value={formData[key] || ""}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                [key]: e.target.value,
                              })
                            }
                          >
                            <option value="">Select Gender</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                            <option value="other">Other</option>
                          </Form.Select>
                        ) : key === "email" ? (
                          <>
                            <Form.Control
                              type="text"
                              name="email"
                              value={formData.email || ""}
                              onChange={EmailhandleChange}
                              className={errors.email ? "is-invalid" : ""}
                            />
                            {errors.email && <div className="text-danger">{errors.email}</div>}
                          </>) : (
                          <Form.Control
                            type="text"
                            name={key}
                            value={formData[key] || ""}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                [key]: e.target.value,
                              })
                            }
                          />
                        )}
                      </Form.Group>
                    </div>
                  ))}
                </div>
              ))}
            </fieldset>

            {/* Address Information */}
            <fieldset className="border p-3 rounded mb-4">
              <legend className="text-primary">Address Information</legend>
              {[
                ["address", "city"], // Pair 1: Address and City
                ["state", "zip"], // Pair 2: State and ZIP
              ].map((pair, index) => (
                <div className="row mb-3" key={index}>
                  {pair.map((key) => (
                    <div className="col-md-6" key={key}>
                      <Form.Group>
                        <Form.Label className="fw-bold">
                          {key.replace("_", " ").toUpperCase()}:{" "}
                          <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name={key}
                          value={formData[key] || ""}
                          onChange={(e) =>
                            setFormData({ ...formData, [key]: e.target.value })
                          }
                        />
                      </Form.Group>
                    </div>
                  ))}
                </div>
              ))}
            </fieldset>

            {/* Insurance Information */}
            <fieldset className="border p-3 rounded mb-4">
              <legend className="text-primary">Insurance Information</legend>
              <div className="row mb-3">
                {/* Insurance Name Field */}
                <div className="col-md-6">
                  <Form.Group>
                    <Form.Label className="fw-bold">
                      Insurance Name: <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      name="primary_insurance_id"
                      value={formData.primary_insurance_id || ""}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          primary_insurance_id: e.target.value,
                        })
                      }
                    >
                      <option value="">Select Primary Insurance</option>
                      {payers.map((payer) => (
                        <option key={payer.id} value={payer.claimMD_id}>
                          {payer.payer_name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </div>

                {/* Insurance Number Field */}
                <div className="col-md-6">
                  <Form.Group>
                    <Form.Label className="fw-bold">
                      Insurance Number: <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="primary_insurance_number"
                      value={formData.primary_insurance_number || ""}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          primary_insurance_number: e.target.value,
                        })
                      }
                    />
                  </Form.Group>
                </div>
              </div>
            </fieldset>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setAddModal(false);
              setFormData("");
            }}
          >
            Close
          </Button>
          <Button
            variant="primary"
            onClick={handleSavePatient}
            disabled={loading || isFormIncomplete}
          >
            Save Patient
          </Button>
        </Modal.Footer>
      </Modal>
      {loading && <CommonSpinner />}
    </div >
  );
};

export default PendingBalances;